// (c) TwistedMinds, Gerry Uytdenhouwen - 3 november 2026

import {isNewOrder} from './ordersTableV2.js';

// Options of the "Selecteer" dropdown on the orders page, in display order.
export const SELECT_OPTIONS = ['all', 'new', 'not_printed', 'not_mailed'];

const MATCHERS = {
    all: () => true,
    new: isNewOrder,
    not_printed: (order) => !order.is_printed,
    not_mailed: (order) => !order.notified_at,
};

/**
 * Orders that match at least one of the chosen options, in list order.
 */
export const selectOrders = (orders, options) => {
    const matchers = (options || []).map(option => MATCHERS[option]).filter(Boolean);
    if (!orders || matchers.length === 0) {
        return [];
    }
    return orders.filter(order => matchers.some(matches => matches(order)));
};

/**
 * The chosen options with `key` switched on or off, in display order.
 * The given array is left untouched.
 */
export const toggleOption = (options, key) => {
    const chosen = new Set(options || []);
    if (chosen.has(key)) {
        chosen.delete(key);
    } else {
        chosen.add(key);
    }
    return SELECT_OPTIONS.filter(option => chosen.has(option));
};
